import { ToastContainer } from "react-toastify";
import { AppContextProvider } from "../AppContext";
import Content from "./Content";
import TableOfContent from "./TableOfContent";

function CoursePreview() {
    return (
        <AppContextProvider>
            <div className="tbcourse-container">
                <TableOfContent/>
                <Content/>
                <ToastContainer/>
            </div>
        </AppContextProvider>
    );
}

export default CoursePreview;
